import ProgressBar from 'components/progress-bar';

import './ProgressBarWithText.styles.css';

interface ProgressBarWithTextProps {
    value: number,
    total: number,
    reversed?: boolean,
    children?: React.ReactElement
}

const ProgressBarWithText = ({ value, total, reversed, children }: ProgressBarWithTextProps) => {
    if (!total) {
        return null;
    }

    return (
        <div className={'progress-bar-with-text' + (reversed ? ' reversed' : '')}>
            <div className="progress-bar-with-text-copy">
                <div className="copy-count">
                    { value } / { total }
                </div>

                {
                    children ? (
                        <div className="copy-additional">
                            { children }
                        </div>
                    ) : null
                }
            </div>

            <div className="progress-bar-with-text-main">
                <ProgressBar showProgress={false} progress={(value / total) * 100} />
            </div>
        </div>
    );
}

export default ProgressBarWithText;
